var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrosoft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4387_52691)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.75 11.25H24V0.75C24 0.336 23.664 0 23.25 0H12.75V11.25Z",
    fill: "#4CAF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25 11.25V0H0.75C0.336 0 0 0.336 0 0.75V11.25H11.25Z",
    fill: "#F44336"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25 12.75H0V23.25C0 23.664 0.336 24 0.75 24H11.25V12.75Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.75 12.75V24H23.25C23.664 24 24 23.664 24 23.25V12.75H12.75Z",
    fill: "#FFC107"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4387_52691"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoft);
export default __webpack_public_path__ + "static/media/microsoft.a5e1ef547f73ac3c091d36722aa2480c.svg";
export { ForwardRef as ReactComponent };